'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';
const _ = {
    find: require('lodash/find'),
    map: require('lodash/map'),
};

const Globals = require('../../../../app/globals');
import ErrorBox from '../common/ErrorBox';
import WarningBox from '../common/WarningBox';
const ForgeError = require('../../util/error');

const propTypes = {
    org_user_id: PropTypes.number.isRequired,
    badgeServices: PropTypes.array.isRequired,
    submitHandler: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
};

const defaultProps = {
    show: true,
};

class OrgAddBadgeServiceModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serviceData: {
                org_user_id: props.org_user_id,
                name: '',
                service_type: Globals.BADGE_SERVICE_TYPES.credly,
                endpoints: {
                    base_api: '',
                },
                credentials: {
                    organization_id: '',
                    token: '',
                }
            },
            missingParamError: "All values must be specified"
        };
    }

    submitHandler=(e)=>{
        this.props.submitHandler(this.state.serviceData);
    }
    
    setServiceType=(e)=>{
        let service_type = e.target.value;
        let serviceData = {...this.state.serviceData, service_type };
        this.setState({serviceData});
    }
    
    doUpdate=(changes)=>{
        let serviceData = changes.serviceData;
        var existingName = _.find(this.props.badgeServices,{name:serviceData.name});
        var duplicateNameError = null;
        var missingParamError = null;
        if (existingName) {
            duplicateNameError = new ForgeError({ message: "Badge service name must be unique" });
        }
        if (!serviceData.name || !serviceData.service_type || !serviceData.endpoints.base_api || !serviceData.credentials.organization_id || !serviceData.credentials.token) {
            missingParamError = "All values must be specified";
        }
        
        this.setState({
            serviceData, 
            duplicateNameError,
            missingParamError,
        });
    }
    
    render() {
        let canSubmit = true;
        if (this.state.duplicateNameError) {
            canSubmit = false;
        }
        
        return (
            <Modal
                show={this.props.show}
                size="lg"
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>{"Add Badge Service"}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group controlId="modal-edit-badge-service-endpoint">
                            <Form.Label>{'Name'}</Form.Label>
                            <Form.Control
                                as={'input'}
                                aria-label={'Name'}
                                value={this.state.serviceData.name}
                                onChange={(e)=>{
                                    this.doUpdate({ 
                                        serviceData: {
                                            ...this.state.serviceData,
                                            name: e.target.value 
                                        }
                                    })
                                }}
                            />
                        </Form.Group>
                        <ErrorBox error={this.state.duplicateNameError} />

                        <Form.Group controlId="modal-edit-badge-service-endpoint">
                            <Form.Label>{'Type'}</Form.Label>
                            <select value={this.state.serviceData.service_type} onChange={this.setServiceType}>
                                {_.map(Globals.BADGE_SERVICE_TYPES,(v,k)=>(
                                    <option key={k} value={v}>{v}</option>      
                                ))}
                            </select>
                        </Form.Group>

                        <Form.Group controlId="modal-edit-badge-service-endpoint">
                            <Form.Label>{'Base API'}</Form.Label>
                            <Form.Control
                                as={'input'}
                                aria-label={'Base Service API'}
                                value={this.state.serviceData.endpoints.base_api}
                                onChange={(e)=>{
                                    this.doUpdate({ 
                                        serviceData: {
                                            ...this.state.serviceData,
                                            endpoints: {
                                                ...this.state.serviceData.endpoints,
                                                base_api: e.target.value 
                                            }
                                        }
                                    })
                                }}
                            />
                        </Form.Group>

                        <Form.Group controlId="modal-edit-badge-credential-org-id">
                            <Form.Label>{'Organization ID'}</Form.Label>
                            <Form.Control
                                as={'input'}
                                aria-label={'Org Id'}
                                value={this.state.serviceData.credentials.organization_id}
                                onChange={(e)=>{
                                    this.doUpdate({ 
                                        serviceData: {
                                            ...this.state.serviceData,
                                            credentials: {
                                                ...this.state.serviceData.credentials,
                                                organization_id: e.target.value 
                                            }
                                        }
                                    })
                                }}
                            />
                        </Form.Group>

                        <Form.Group controlId="modal-edit-badge-credential-auth-token">
                            <Form.Label>{'Auth Token'}</Form.Label>
                            <Form.Control
                                as={'input'}
                                aria-label={'Auth Token'}
                                value={this.state.serviceData.credentials.token}
                                onChange={(e)=>{
                                    this.doUpdate({ 
                                        serviceData: {
                                            ...this.state.serviceData,
                                            credentials: {
                                                ...this.state.serviceData.credentials,
                                                token: e.target.value 
                                            }
                                        }
                                    })
                                }}
                            />
                        </Form.Group>

                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button disabled={!canSubmit} onClick={this.submitHandler}>
                        add badge service
                    </Button>
                    {this.state.missingParamError ? <WarningBox>{this.state.missingParamError}</WarningBox> : null }
                </Modal.Footer>
            </Modal>
        );
    }
}

OrgAddBadgeServiceModal.propTypes = propTypes;
OrgAddBadgeServiceModal.defaultProps = defaultProps;

export default OrgAddBadgeServiceModal;